import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { IpInfo } from '@model/ip-info';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class IpInfoApiService {
  private httpClient = inject(HttpClient);

  public getIpInfo(): Observable<IpInfo> {
    return this.httpClient.get<IpInfo>(
      'https://ipinfo.io?token=a1f9dcb70b8e83',
    );
  }
}
